(() => {
  'use strict';
  if (window.sayuriProductPresentationLoaded) return;
  window.sayuriProductPresentationLoaded = true;

  const savingsPercent = (variant) => {
    const compare = Number(variant?.compare_at_price || 0);
    const price = Number(variant?.price || 0);
    return compare > price ? Math.round(((compare - price) / compare) * 10) * 10 : 0;
  };

  function updateVariant(root, variant) {
    if (!root) return;
    const saving = root.querySelector('[data-sayuri-saving]');
    if (saving) {
      const onSale = variant && Number(variant.compare_at_price) > Number(variant.price);
      saving.hidden = !onSale;
      if (onSale) saving.textContent = `節約する ${savingsPercent(variant)}%`;
    }
    const stock = root.querySelector('[data-sayuri-stock]');
    if (stock) {
      const available = Boolean(variant?.available);
      stock.textContent = available ? '在庫あり、残りわずか!' : '売り切れ';
      stock.closest('[data-sayuri-stock-row]')?.classList.toggle('is-unavailable', !available);
    }
  }

  function nextBusinessDay(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
    date.setUTCDate(date.getUTCDate() + 1);
    while (date.getUTCDay() === 0 || date.getUTCDay() === 6) date.setUTCDate(date.getUTCDate() + 1);
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    return `${date.getUTCMonth() + 1}月${date.getUTCDate()}日 (${weekdays[date.getUTCDay()] }.)`;
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-sayuri-ship-date]').forEach(el => { el.textContent = nextBusinessDay(); });
    scope.querySelectorAll('product-component').forEach(root => {
      if (!root.querySelector('.sayuri-stars-wrap')) return;
      const data = root.querySelector('[data-product-json]');
      if (!data) return;
      try {
        const product = JSON.parse(data.textContent);
        const id = root.querySelector('input[name="id"][form]')?.value;
        const variant = product.variants.find(item => String(item.id) === String(id)) || product.variants[0];
        updateVariant(root, variant);
      } catch (_) { /* Liquid output remains the fallback if product data is unavailable. */ }
    });
  }

  document.addEventListener('theme:variant:change', event => {
    updateVariant(event.target.closest('product-component'), event.detail?.variant);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
